export function hasLettersAndNumbers(str: string) {
  const hasLetters = /[a-zA-Z]/.test(str);
  const hasNumbers = /\d/.test(str);
  return hasLetters && hasNumbers;
}
